import { toApiError } from '@/shared/api';
import { problemText } from '@/shared/api/problemText';

const NO_ANSWER = new Set([0, 502, 503, 504]);

/** Die Codes aus `CleaningTeamErrors` (PascalCase, deshalb hier statt über die Code-Erkennung). */
const TEAM_PROBLEMS: Record<string, string> = {
  'CleaningTeam.NameTaken': 'Ein Team mit diesem Namen gibt es schon.',
  'CleaningTeam.Conflict':
    'Das Team wurde inzwischen geändert. Öffne es neu für den aktuellen Stand.',
  'CleaningTeam.NotFound': 'Das Team gibt es nicht mehr.',
  'CleaningTeam.CompanyNotFound': 'Die gewählte Firma gibt es nicht mehr.',
  'CleaningTeam.MemberNotFound': 'Eine gewählte Person ist nicht mehr aktiv.',
  'CleaningTeam.MemberRoleInvalid': 'Eine gewählte Person kann diese Rolle im Team nicht haben.',
  'CleaningTeam.DuplicateMember': 'Eine Person steht doppelt im Team.',
  'CleaningTeam.PropertyGroupNotFound': 'Ein gewähltes Objekt gibt es nicht mehr.',
  'CleaningTeam.DuplicatePropertyGroup': 'Ein Objekt ist doppelt gewählt.',
  'CleaningTeam.PropertyScopeForbidden': 'Ein gewähltes Objekt liegt außerhalb deines Zugriffs.',
};

/**
 * Satz zu einem gescheiterten Speichern. `unknown`: ohne Antwort ist offen, ob es gespeichert ist;
 * `stale`: der Dialog hält einen überholten Stand und muss neu geöffnet werden.
 */
export async function teamFailure(
  error: unknown,
): Promise<{ text: string; unknown: boolean; stale: boolean }> {
  const problem = await toApiError(error);
  if (NO_ANSWER.has(problem.status))
    return {
      text: 'Keine Antwort vom Server – ob das Team gespeichert ist, zeigt die neu geladene Liste.',
      unknown: true,
      stale: false,
    };
  return {
    text: problemText(problem, 'Team nicht gespeichert.', { known: TEAM_PROBLEMS }),
    unknown: false,
    stale: problem.title === 'CleaningTeam.Conflict' || problem.title === 'CleaningTeam.NotFound',
  };
}
